import React from 'react'
import PropTypes from 'prop-types'
import styled, { css, withTheme } from 'styled-components'

const PATTY_POSITIONS = {
  X: {
    bottom: props => css`
      ${
        props.open
          ? `top: 0px;`
          : `top: ${props.heightPx - props.pattyHeightPx}px;`
      }
      transform-origin: ${props.pattyHeightPx / 2}px
        ${props.pattyHeightPx / 2}px;
      ${
        props.open
          ? `transform: rotate(${Math.atan(props.heightPx / props.widthPx) *
              (180 / Math.PI)}deg);`
          : `transform: rotate(0deg);`
      }
      ${
        props.open
          ? `width: ${Math.sqrt(props.widthPx ** 2 + props.heightPx ** 2) -
              props.pattyHeightPx}px;`
          : `width: ${props.widthPx - 1}px;`
      }
    `,
    middle: props => css`
      opacity: ${props.open ? 0 : 1};
      top: ${(props.heightPx - 1) / 2 - (props.pattyHeightPx - 1) / 2}px;
      width: ${props.widthPx - 1}px;
    `,
    top: props => css`
      ${
        props.open
          ? `top: ${props.heightPx - props.pattyHeightPx}px;`
          : `top: 0px;`
      }
      transform-origin: 0px ${props.pattyHeightPx / 2}px;
      ${
        props.open
          ? `transform: rotate(-${Math.atan(props.heightPx / props.widthPx) *
              (180 / Math.PI)}deg);`
          : `transform: rotate(0deg);`
      }
      ${
        props.open
          ? `width: ${Math.sqrt(props.widthPx ** 2 + props.heightPx ** 2) -
              props.pattyHeightPx}px;`
          : `width: ${props.widthPx - 1}px;`
      }
    `
  },
  doubleFlat: {
    bottom: props => css`
      ${
        props.open
          ? `top: 0px;`
          : `top: ${(props.heightPx * 0.8) - props.pattyHeightPx}px;`
      }
      transform-origin: ${props.pattyHeightPx / 2}px
        ${props.pattyHeightPx / 2}px;
      ${
        props.open
          ? `transform: rotate(45deg);`
          : `transform: rotate(0deg);`
      }
      ${
        props.open
          ? `width: ${Math.sqrt(props.widthPx ** 2 + props.heightPx ** 2) -
              props.pattyHeightPx}px;`
          : `width: ${props.widthPx - 1}px;`
      }
    `,
    middle: () => css`
      opacity: 0;
      display: none;
    `,
    top: props => css`
      ${
        props.open
          ? `top: ${props.heightPx}px;`
          : `top: ${props.heightPx * 0.2}px;`
      }
      transform-origin: 0px ${props.pattyHeightPx / 2}px;
      ${
        props.open
          ? `transform: rotate(-45deg);`
          : `transform: rotate(0deg);`
      }
      ${
        props.open
          ? `width: ${Math.sqrt(props.widthPx ** 2 + props.heightPx ** 2) -
              props.pattyHeightPx}px;`
          : `width: ${props.widthPx - 1}px;`
      }
    `
  }
}

const ShakeShackPatty = styled.div`
  position: absolute;
  transition: all 0.4s ease;
  display: block;
  height: ${props => props.pattyHeightPx}px;
  background: ${props => props.color};
  /* insert patty specific designs */
  ${props => PATTY_POSITIONS[props.pattyPositions][props.patty]}
`


const asMap = {
  "button": styled.button.attrs({ type: 'button' })`
  position: relative;
  width: ${props => props.widthPx}px;
  height: ${props => props.heightPx}px;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  cursor: pointer;
  :focus ~ ${ShakeShackPatty} {
    background-color: ${props => props.theme.colors.primary};
  }
  `,
  "div": styled.div`
  position: relative;
  width: ${props => props.widthPx}px;
  height: ${props => props.heightPx}px;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  cursor: pointer;
  :focus ~ ${ShakeShackPatty} {
    background-color: ${props => props.theme.colors.primary};
  }
  `,
}


const Hamburger = ({
  toggle,
  open,
  widthPx,
  heightPx,
  pattyPositions,
  pattyHeightPx,
  as,
  color,
  theme
}) => {
  if (!color) color = theme.colors.text.menuItem
  const commonProps = { open, widthPx, heightPx, pattyPositions, pattyHeightPx, color }
  const Container = asMap[as];
  return (
    <Container onClick={toggle} widthPx={widthPx} heightPx={heightPx}>
      <ShakeShackPatty patty="top" {...commonProps} />
      <ShakeShackPatty patty="middle" {...commonProps} />
      <ShakeShackPatty patty="bottom" {...commonProps} />
    </Container>
  )
}

Hamburger.defaultProps = {
  widthPx: 25,
  heightPx: 19,
  pattyHeightPx: 3,
  pattyPositions: 'X',
  as: "button",
  color: undefined
}

Hamburger.propTypes = {
  widthPx: PropTypes.number,
  heightPx: PropTypes.number,
  pattyHeightPx: PropTypes.number,
  pattyPositions: PropTypes.oneOf(Object.keys(PATTY_POSITIONS)),
  as: PropTypes.oneOf(["button", "div"]),
  color: PropTypes.string
}

export default withTheme(Hamburger)
